import { PromoCodeDisplay } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory<EntityType<PromoCodeDisplay>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const setupOfflinePaymentReducer = createReducer<State, Actions>(initialState, {
  [actions.setupOfflinePayment.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.setupOfflinePayment.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.setupOfflinePayment.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.setupOfflinePayment.reset.type]: actionsHandlers.handleSingleFeatureReset,
  [actions.resetCreatingOrder.type]: actionsHandlers.handleSingleFeatureReset,
});

export default setupOfflinePaymentReducer;
